'use strict';

import signTemplate from './signin.html';
import Signin from './signin.ctrl';

function signinRouter($stateProvider) {
  $stateProvider
    .state('signin', {
      url: '/signin?:email',
      template: signTemplate,
      controller: 'SigninController as vm',
      resolve: {
        checkTranslationFilesLoaded: (I18nService) => {
          return I18nService.ensureLoaded();
        }
      }
    });
}

export default angular
  .module('signin.router', [
    Signin
  ])
  .config(signinRouter)
  .name;
